import './ui/styles.css';
import { startApp } from './app';

const root = document.getElementById('app');
const topbar = document.getElementById('topbar');
if (!root || !topbar) throw new Error('#app ou #topbar introuvable');
startApp(root, topbar);
